<template>
  <div class="material_box">
    <div class="material_l">
      <div class="material_l_title">素材分类</div>
      <div class="material_l_b">
        <div class="tree_outbox">
          <el-tree :data="folderTree" ref="folderTree" :props="defaultProps" :default-expanded-keys="[...expandedKeys]" icon-class="el-icon-arrow-right el-icon-arrow-down" @node-click="treeNodeClick" node-key="id" highlight-current>
            <div slot-scope="{ node, data }">
              <img v-if="data.children" :src="require(`@/assets/images/folder-${node.expanded ? `o` : `c`}.png`)" class="folderimg" />
              <span>{{ node.label }}</span>
            </div>
          </el-tree>
        </div>
      </div>
    </div>
    <div class="material_r">
      <div class="material_r_title">{{ currentFolderName }}</div>
      <el-form inline :model="searchForm" class="form_inline_search">
        <el-form-item label="关键词">
          <el-input v-model="searchForm.keyword" placeholder="请输入内容" style="width: 150px;"></el-input>
        </el-form-item>
        <el-form-item label="起止时间">
          <el-date-picker
            v-model="searchTime"
            type="datetimerange"
            style="width: 260px;"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <div class="choose_item">
            <span v-for="item in types" :class="{is_active: searchForm.ext == item.value}" @click="searchForm.ext = item.value">
              {{ item.label }}
            </span>
          </div>
        </el-form-item>
        <el-form-item label="账号">
          <el-select v-model="searchForm.user_id" placeholder="请选择" style="width: 150px;">
            <el-option
              v-for="item in subAccountList"
              :key="item.id"
              :label="item.nickname"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-button class="search_btn" @click="tableSearch">搜索</el-button>
        <el-button class="reset_btn" @click="tableReset">重置</el-button>
      </el-form>
      <div class="material_r_o">
        <div class="material_r_sort">
          <!-- <div>更新时间 <i class="el-icon-caret-bottom el-icon-caret-top"></i></div> -->
          <div @click="changeTableSort" style="cursor: pointer;">
            加入时间 <i :class="searchForm.sort == 'asc' ? 'el-icon-caret-bottom' : 'el-icon-caret-top'"></i>
          </div>
          <svg-icon icon-class="line" :class="{'no-active': arrangeType == 'grid'}" @click="arrangeType = 'line'" />
          <svg-icon icon-class="grid" :class="{'no-active': arrangeType == 'line'}" @click="arrangeType = 'grid'" />
        </div>
        <div>
          <!-- <el-button class="material_r_btn is_add" size="medium" @click="openDialogs('newfile')">批量上传图片</el-button> -->
          <el-button class="material_r_btn is_add" size="medium" @click="openDialogs('newfolder')">新建文件夹</el-button>
          <el-button class="material_r_btn is_add" size="medium" @click="openDialogs('imagesearch')">以图搜款</el-button>
          <!-- 新建文件夹 -->
          <!-- <new-folder :activeID="activeID" @update="tableUpdate" /> -->
          <el-button
            class="material_r_btn"
            @click="removeSingle(false)"
            :disabled="!multipleSelection.length"
            size="medium"
            >移动到</el-button
          >
          <!-- 编辑素材 -->
          <!-- <edit-material
            ref="editMaterial"
            :list.sync="emitChildData"
            :isEdit="isEdit"
            @updateMaterial="updateMaterial"
            @update="tableUpdate"
          /> -->
          <!-- 更多操作  共享：shared; 取消共享：cancelShared; 指定分享：specifyShared-->
          <el-button
            class="material_r_btn"
            @click="specifyShared('')"
            :disabled="!multipleSelection.length > 0"
            size="medium"
            >共享</el-button
          >
          <!-- <more-settings
            :dStatus="multipleSelection.length > 0"
            @shared="sharedLibrary"
            @cancelShared="cancelShared"
            @specifyShared="specifyShared"
          /> -->
          <!-- 批量删除 -->
          <!-- <el-button
            class="material_r_btn"
            size="medium"
            @click="batchDeletion('')"
            :disabled="!multipleSelection.length"
            >批量删除</el-button
          > -->
          <!-- 批量下载 -->
          <!-- <el-button
            class="material_r_btn"
            size="medium"
            @click="downloadZip"
            :disabled="!isEdit"
            >批量下载</el-button
          > -->
          <el-button
            class="material_r_btn"
            size="medium"
            @click="tempExport"
            :disabled="!isEdit"
            >按模版导出</el-button
          >
          <el-dropdown>
            <el-button class="material_r_btn" size="medium">
              批量操作<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="openDialogs('newfile')">批量上传图片</el-dropdown-item>
              <el-dropdown-item @click.native="batchDeletion('')" :disabled="!multipleSelection.length">批量删除</el-dropdown-item>
              <el-dropdown-item @click.native="downloadZip" :disabled="!isEdit">批量下载</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <ImageOperate v-if="isEdit" ref="ImageOperateRef" class="image_operate" :imageList="multipleSelection" />
        </div>
      </div>
      <div v-if="arrangeType == 'line'">
        <!-- 表格 -->
        <el-table
          :data="libraryTableData"
          @selection-change="handleSelectionChange"
          ref="goodsMultiple"
          v-loading="tableLoading"
          class="main_table"
          row-key="id"
        >
          <el-table-column
            reserve-selection
            type="selection"
            width="50"
            :selectable="(row) => !row.is_shared"
          ></el-table-column>
          <el-table-column label="素材" width="108">
            <template slot-scope="scope">
              <div
                class="material-box"
                v-if="isFolder(scope.row.type)"
                style="align-items: center"
              >
                <el-popover placement="right-start" trigger="hover" popper-class="material-hover" :width="450">
                    <img
                      class="hover-img"
                      :src="scope.row.thumb1200"
                    />
                  <el-image
                    class="material-img"
                    slot="reference"
                    :src="scope.row.thumb"
                    fit="cover"
                  ></el-image>
                </el-popover>
                <!-- <p class="material-item">
                  {{ scope.row.name }}
                </p> -->
              </div>
              <div class="material-box" v-else>
                <div class="material-file" @dblclick="openFile(scope.row)">
                  <div class="material-file-box">
                    <img
                      class="material-file-img"
                      src="@/assets/images/folder.png"
                    />
                  </div>
                  <p class="text">双击打开文件夹</p>
                </div>
                <!-- <p class="material-item">{{ scope.row.name }}</p> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column label="名称" property="name">
          </el-table-column>
          <el-table-column
            label="创建人"
            property="nickname"
            width="170"
          ></el-table-column>
          <el-table-column label="时间" width="300">
            <template slot-scope="scope">
              <p>创建时间：{{ scope.row.create_time || '--' }}</p>
              <p>更新时间：{{ scope.row.update_time || '--' }}</p>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="250">
            <template slot-scope="scope">
                <el-button type="text" @click="editSoleFolder(scope.row)">编辑</el-button>
                <el-button type="text" @click="specifyShared(scope.row)" v-if="!scope.row.is_shared">共享</el-button>
                <el-button type="text" @click="removeSingle(scope.row)" v-if="!scope.row.is_shared">移动到</el-button>
                <el-button type="text" @click="downloadSingleImage(scope.row.url, scope.row.name)" v-if="isFolder(scope.row.type)">
                  下载
                </el-button>
                <el-button type="text" style="color: #F72D2D" @click="batchDeletion(scope.row)" v-if="!scope.row.is_shared">
                  删除
                </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="main_pagination"
          background
          layout="prev, pager, next, sizes"
          :page-sizes="[100, 200, 500, 1000, 2000]"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="searchForm.limit"
          :total="tableTotal">
        </el-pagination>
      </div>
      <el-checkbox-group v-model="multipleSelection" class="material_r_grid" @change="handleSelectionChange" v-infinite-scroll="gridScrollBottom" :infinite-scroll-disabled="tableLoading || gridNoMore" v-else>
        <div v-for="item in libraryTableData" :class="isFolder(item.type) ? 'material_grid_file' : 'material_grid_folder'">
          <div class="material_grid_mask">
            <el-checkbox :label="item" :key="item.id"></el-checkbox>
            <div class="mask_opratebox">
              <img src="@/assets/images/m-download.png" v-if="isFolder(item.type)" @click="downloadSingleImage(item.url, item.name)" />
              <img src="@/assets/images/m-edit.png" v-if="!item.is_shared" @click="editSoleFolder(item)" />
              <img src="@/assets/images/m-remove.png" v-if="!item.is_shared" @click="removeSingle(item)" />
              <img src="@/assets/images/m-share.png" v-if="!item.is_shared" @click="specifyShared(item)" />
              <img src="@/assets/images/m-delete.png" v-if="!item.is_shared" @click="batchDeletion(item)" />
            </div>
            <div class="mask_textbox" @dblclick="openFile(item)">
              <div>{{ item.name }}</div>
              <div class="mask_time">创建时间：{{item.create_time || '--'}}</div>
              <div class="mask_time">创建时间：{{item.update_time || '--'}}</div>
            </div>
          </div>
          <el-image
            class="material-grid-img"
            v-if="isFolder(item.type)"
            :src="item.thumb"
            fit="contain"
          ></el-image>
          <img
            class="material-grid-img"
            v-else
            src="@/assets/images/folder.png"
          />
        </div>
        <div v-if="tableLoading" style="width: 100%;font-size: 14px;text-align: center;color: #ccc">加载中...</div>
      </el-checkbox-group>
    </div>

      <!-- 指定共享弹窗 -->
      <specify-share ref="specifyShare" :list="emitChildData" />
      <!-- 移动到 -->
      <collection-material-library
        ref="collection"
        @submit="handleMoveFile"
        title="移动到"
        :isFilter="true"
      />
      <!-- 新建文件夹 -->
      <new-folder ref="newfolder" :activeID="searchForm.parent_id" @update="tableUpdate" />
      <!-- 上传文件 -->
      <library-upload ref="newfile" :activeID="searchForm.parent_id" @update="tableUpdate" />
      <!-- 以图搜款 -->
      <image-search ref="imagesearch"  />
      <!-- 按模板导出 -->
      <ExportAccordTemp ref="ExportAccordTempRef" pageType="material" :dataIds="group_ids" />
      <el-backtop :visibility-height="120"></el-backtop>
  </div>
</template>
<script>
import LibraryUpload from "./components/LibraryUpload";
import NewFolder from "@/components/NewFolder";
import EditMaterial from "./components/EditMaterial";
import SpecifyShare from "./components/SpecifyShare";
import ImageSearch from "./components/ImageSearch.vue";
import CollectionMaterialLibrary from "@/components/CollectionMaterialLibrary.vue";
import ExportAccordTemp from "@/components/ExportAccordTemp.vue";
import ImageOperate from "@/components/ImageOperate.vue";
import { materialGetList, folderGetTree, folderEdit, folderFileMove, folderFileDelete } from '@/api/material'
import { subGetList } from '@/api/subaccount'
import { downloadImages, downloadSingleImage } from '@/utils/download'
export default {
  name: "material",
  components: {
    LibraryUpload,
    NewFolder,
    EditMaterial,
    SpecifyShare,
    ImageSearch,
    CollectionMaterialLibrary,
    ExportAccordTemp,
    ImageOperate
  },
  data () {
   return {
    expandedKeys: [0,],
    currentFolderName: '全部',
    folderTree: [{
      id: 0,
      name: "全部",
      type: 1,
      children: []
    }],
    defaultProps: {
      // children: 'children',
      label: 'name'
    },

    subAccountList: [],
    types: [{
      label: '全部',
      value: ''
      }, {
      label: 'JPG',
      value: 'JPG'
      }, {
      label: 'PNG',
      value: 'PNG'
      }
    ],
    options: [],
    arrangeType: 'line',

    // 分页器属性
    gridNoMore: false,
    tableLoading: false,
    libraryTableData: [],
    tableTotal: 0,
    multipleSelection: [],
    searchTime: [],
    searchForm: {
      parent_id: 0,
      keyword: '',
      ext: '',
      start_time: '',
      end_time: '',
      user_id: '',
      sort: 'asc',
      page: 1,
      limit: 100
    },

    //  发送给子组件的数据
    emitChildData: [],
    group_ids: []
   }
  },
  created() {
    this.getSubList()
    this.getFolderTree()
    this.getMaterialList()
  },
  computed: {
    // 判断是否可编辑
    isEdit() {
      return (
        this.multipleSelection.length > 0 &&
        this.multipleSelection.every((item) => {
          return item.type == 2;
        })
      );
    },
  },
  methods: {
    downloadSingleImage,
    openDialogs(command) {
      this.$refs[command].dialogTableVisible = true
    },
    // 点击文件夹目录时
    treeNodeClick(data) {
      this.currentFolderName = data.name
      this.searchForm.parent_id = data.id;
      this.searchForm.page = 1;
      this.multipleSelection = [];
      if(this.$refs.goodsMultiple) {
        this.$refs.goodsMultiple.clearSelection();
      }
      if(this.arrangeType == 'grid') {
        this.libraryTableData = []
      }
      this.getMaterialList();
      // }
    },
    // 移动到
    removeSingle(data) {
      let c = this.$refs.collection;
      if (data) {
        c.sourceList = [
          {
            id: data.id,
            type: data.type,
          },
        ];
      } else {
        c.sourceList = this.multipleSelection.map((item) => {
          return {
            id: item.id,
            type: item.type,
          };
        });
      }
      c.dialogTableVisible = true;
      // c.catalogue = this.folderTree
    },
    handleMoveFile(idlist, targetId) {
      let file_ids = []
      let folder_ids = []
      idlist.forEach(item => {
        if(item.type == 1) {
          folder_ids.push(item.id) 
        }else {
          file_ids.push(item.id)
        }
      })
      folderFileMove({file_ids, folder_ids, target_folder_id: targetId}).then((res) => {
        this.multipleSelection = [];
        if(this.$refs.goodsMultiple) {
          this.$refs.goodsMultiple.clearSelection();
        }
        this.$message.success('移动成功');
        this.tableUpdate()
      });
    },
    // 设置编辑素材列表
    updateMaterial() {
      this.emitChildData = this.multipleSelection;
    },
    // 指定分享
    specifyShared(item) {
      //  单文件指定分享时
      if (item) {
        this.emitChildData = [item];
      } else {
        // 多文件指定分享时
        this.emitChildData = this.multipleSelection;
      }
      this.$refs.specifyShare.dialogVisible = true;
      // this.$refs.specifyShare.subAccount = "";
      // this.$refs.specifyShare.account = [];
      // this.$refs.specifyShare.checked = false;
    },
    // 按模板导出
    tempExport() {
      this.group_ids = this.multipleSelection.map(item => {return {id: item.id}});
      if(this.group_ids.length) {
        this.$refs.ExportAccordTempRef.dialogTempVisible = true
      }else {
        this.$message.warning("请选择要按模板导出的图片");
      }
    },
    /* 删除 */
    batchDeletion(data) {
      var that = this;
      this.$confirm("确定删除文件?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (data) {
            that.deleteFolder(data.type == 1 ? {folder_ids: [data.id]} : {file_ids: [data.id]});
          } else {
            let folder_ids = []
            let file_ids = []
            that.multipleSelection.forEach((item) => {
              if(item.type == 1) {
                folder_ids.push(item.id)
              }else {
                file_ids.push(item.id)
              }
            });
            that.deleteFolder({folder_ids, file_ids});
          }
        })
        .catch(() => {});
    },
    deleteFolder(data) {
      this.tableLoading = true;
      folderFileDelete(data).then((res) => {
        this.tableLoading = false;
          this.tableUpdate();
          this.multipleSelection = [];
          if(this.$refs.goodsMultiple) {
            this.$refs.goodsMultiple.clearSelection();
          }
        this.$message.success(res.data);
      });
    },
    /* 表格选中事件 */
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 双击打开文件夹
    openFile(item) {
      if(this.arrangeType == 'grid') {
        this.libraryTableData = []
      }
      this.multipleSelection = []
      if(this.$refs.goodsMultiple) {
        this.$refs.goodsMultiple.clearSelection();
      }
      this.searchForm.page = 1;
      this.currentFolderName = item.name
      // this.expandedKeys.push(item.id)
      this.expandedKeys[1] = item.id
      this.$refs.folderTree.setCurrentKey(item.id);
      this.searchForm.parent_id = item.id
      this.getMaterialList();
    },
    //   编辑单个文件夹
    editSoleFolder(item) {
      this.$prompt('请输入名称', '编辑', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValidator: (value) => {
          if(!value) {
            return '名称不能为空'
          }
        }
      }).then(({ value }) => {
        if(this.isFolder(item.type)) {
          fileEdit({file_id: item.id, name: value}).then(res => {
            this.$message.success('修改成功')
            this.tableUpdate()
          })
        }else {
          folderEdit(item.id, {name: value}).then(res => {
            this.$message.success('修改成功')
            this.tableUpdate()
          })
        }
      })
    },
    //   编辑图片素材
    editMaterial(item) {
      //  单文件
      if (item) {
        this.emitChildData = [item];
      } else {
        // 多文件
        this.emitChildData = this.multipleSelection;
      }
      this.$refs.editMaterial.drawer = true;
    },
    async downloadZip() {
      // this.$emit("updateLoad");
      let list = JSON.stringify(this.multipleSelection);
      list = JSON.parse(list);
      let dataList = list.map((item) => {
        return item;
      });
      downloadImages(dataList, '素材包')
    },
    gridScrollBottom() {
      this.searchForm.page++
      this.getMaterialList()
    },
    getMaterialList() {
      this.tableLoading = true
      materialGetList(this.searchForm).then((res) => {
        if(this.arrangeType == 'grid') {
          this.libraryTableData = this.libraryTableData.concat(res.data.data)
          this.gridNoMore = this.libraryTableData.length == res.data.total
        }else {
          this.libraryTableData = res.data.data
        }
        this.tableTotal = res.data.total;
        this.tableLoading = false;
      });
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getMaterialList();
    },
    handleSizeChange(val) {
      this.searchForm.limit = val
      this.searchForm.page = 1
      this.getMaterialList()
    },
    //更新数据
    tableUpdate() {
      this.getMaterialList();
      this.getFolderTree();
    },
    /*
      判断文件类型
      为1是普通文件夹，2是文件
    */
    //
    isFolder(type) {
      return type == 2;
    },
    changeTableSort() {
      this.searchForm.sort = this.searchForm.sort == 'asc' ? 'desc' : 'asc'
      this.getMaterialList();
    },
    tableSearch() {
      if(this.searchTime && this.searchTime.length) {
        this.searchForm.start_time = this.searchTime[0]
        this.searchForm.end_time = this.searchTime[1]
      }else {
        this.searchForm.start_time = ''
        this.searchForm.end_time = ''
      }
      this.searchForm.page = 1
      this.getMaterialList();
    },
    tableReset() {
      this.searchForm.page = 1
      this.searchForm.keyword = ''
      this.searchForm.ext = ''
      this.searchTime = []
      this.searchForm.start_time = ''
      this.searchForm.end_time = ''
      this.searchForm.user_id = ''
      this.getMaterialList();
    },
    getFolderTree() {
      folderGetTree().then(res => {
        this.folderTree[0].children = res.data
      })
    },
    getSubList() {
      subGetList().then(res => {
        this.subAccountList = res.data
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.material_box {
  display: flex;
  height: 100%;
  .material_l {
    width: 300px;
    height: calc(100vh - 77px - 48px);
    background: #FFFFFF;
    color: #595959;
    padding: 16px;
    display: flex;
    flex-direction: column;
    border-radius: 8px;
    flex-shrink: 0;
    .material_l_title {
      font-size: 14px;
      font-weight: 500;
      padding-bottom: 9px;
      border-bottom: 1px solid #EDEDED;
    }
    .material_l_b {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex: 1;
      overflow: auto;
      .tree_outbox {
        flex: 1;
        overflow-y: auto;
        // padding-bottom: 16px;
        .el-tree {
          background: transparent;
          color: #737373;
          /deep/ .el-tree-node:focus>.el-tree-node__content {
            background: transparent;
          }
          /deep/ .el-tree-node.is-current>.el-tree-node__content {
            background: rgba(204, 204, 204, 0.25);
            border-radius: 4px;
          }
          /deep/ .el-tree-node__content {
            margin-top: 18px;
            font-size: 14px;
            height: 32px;
            .el-tree-node__expand-icon {
              color: #737373;
              &.is-leaf {
                color: transparent;
              }
            }
            .folderimg {
              margin-right: 12px;
              vertical-align: bottom;
            }
            &:hover {
              background: transparent;
            }
          }
          /deep/ .el-tree-node__children .el-tree-node__content {
            margin-top: 12px;
          }
        }
      }
    }
  }
  .material_r {
    border-radius: 8px;
    background: #FFFFFF;
    flex: 1;
    margin-left: 24px;
    padding: 0 16px;
    // 因为flex导致窗口缩小时不能跟着缩放 min-width: 0 可以解决
    min-width: 0;
    .material_r_title {
      font-size: 24px;
      margin: 24px 0 16px;
    }
    .choose_item {
      // border-radius: 4px;
      // background: rgba(70, 83, 122, .4);
      // padding: 12px 7px;
      // line-height: 50px;
      span {
        color: #737373;
        display: inline-block;
        padding: 6px 14px;
        font-size: 12px;
        line-height: 1;
        cursor: pointer;
        &.is_active {
          color: #FFFFFF;
          border-radius: 4px;
          background: #66708C;
        }
      }
    }
    .material_r_o {
      padding: 16px;
      border-bottom: 1px solid #2C3254;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .material_r_sort {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        color: #737373;
        i {
          margin-left: 8px;
          margin-right: 24px;
          cursor: pointer;
        }
        .svg-icon {
          font-size: 20px;
          margin-right: 16px;
          cursor: pointer;
          &.no-active {
            color: #B3B3B3;
          }
        }
      }
      .image_operate /deep/ .temp_plain, .material_r_btn {
        background: transparent;
        border: 1px solid #132632;
        color: #132632;
        &+.material_r_btn {
          margin-left: 24px;
        }
        &.is_add {
          background: linear-gradient(90deg, #132632 0%, #3E4B4F 100%);
          color: #F7F8FA;
        }
      }
      .image_operate /deep/ .temp_plain {
        padding: 10px 20px;
        font-size: 14px;
        border-radius: 4px;
        line-height: 1;
        width: auto;
        height: auto;
        margin-left: 24px;
      }
      .el-dropdown {
        margin-left: 24px;
      }
    }

    .material-box {
      display: flex;
    }


    .material-img-box,
    .material-file-box {
      width: 88px;
      height: 88px;
      margin-right: 12px;
      border-radius: 4px;
      position: relative;

    }
    .material-img, .material-file-img {
      width: 88px;
      height: 88px;
      margin-right: 12px;
      border-radius: 4px;
    }
    .material-img {
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAIAAABLixI0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAFHGlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxNDUgNzkuMTYzNDk5LCAyMDE4LzA4LzEzLTE2OjQwOjIyICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyIgeG1sbnM6cGhvdG9zaG9wPSJodHRwOi8vbnMuYWRvYmUuY29tL3Bob3Rvc2hvcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RFdnQ9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZUV2ZW50IyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ0MgMjAxOSAoV2luZG93cykiIHhtcDpDcmVhdGVEYXRlPSIyMDE5LTEwLTIyVDE2OjMxOjQ5KzA4OjAwIiB4bXA6TW9kaWZ5RGF0ZT0iMjAxOS0xMC0yMlQxNjozMzoyMiswODowMCIgeG1wOk1ldGFkYXRhRGF0ZT0iMjAxOS0xMC0yMlQxNjozMzoyMiswODowMCIgZGM6Zm9ybWF0PSJpbWFnZS9wbmciIHBob3Rvc2hvcDpDb2xvck1vZGU9IjMiIHBob3Rvc2hvcDpJQ0NQcm9maWxlPSJzUkdCIElFQzYxOTY2LTIuMSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpmZGJmY2E1NC04Yzc4LTk3NGMtOGYyNC0xMmQ5MTMxNDI1ODgiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6ZmRiZmNhNTQtOGM3OC05NzRjLThmMjQtMTJkOTEzMTQyNTg4IiB4bXBNTTpPcmlnaW5hbERvY3VtZW50SUQ9InhtcC5kaWQ6ZmRiZmNhNTQtOGM3OC05NzRjLThmMjQtMTJkOTEzMTQyNTg4Ij4gPHhtcE1NOkhpc3Rvcnk+IDxyZGY6U2VxPiA8cmRmOmxpIHN0RXZ0OmFjdGlvbj0iY3JlYXRlZCIgc3RFdnQ6aW5zdGFuY2VJRD0ieG1wLmlpZDpmZGJmY2E1NC04Yzc4LTk3NGMtOGYyNC0xMmQ5MTMxNDI1ODgiIHN0RXZ0OndoZW49IjIwMTktMTAtMjJUMTY6MzE6NDkrMDg6MDAiIHN0RXZ0OnNvZnR3YXJlQWdlbnQ9IkFkb2JlIFBob3Rvc2hvcCBDQyAyMDE5IChXaW5kb3dzKSIvPiA8L3JkZjpTZXE+IDwveG1wTU06SGlzdG9yeT4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6l0qErAAAASklEQVQ4je3TwQkAMQhEUWdJYZZuW4JgOohzCSxk5vx5B0F0t02LiLExs4+JyMmS9aK1yF+jLLJz97H5671kybppsT9UVZl5CABsVSkOV58tY+kAAAAASUVORK5CYII=);
      background-repeat: repeat;
    }

    .material-item {
      span {
        color: #8c8c8c;
      }
    }

    .material-file {
      position: relative;
      cursor: pointer;

      .text {
        position: absolute;
        display: none;
        bottom: 0;
        left: 0;
        padding: 2px;
        background-color: rgba(0, 0, 0, 0.4);
        font-size: 12px;
        text-align: center;
      }

      &:hover .text {
        display: inline-block;
        color: #fff;
      }
    }
    .material_r_grid {
      margin-top: 32px;
      margin-bottom: 32px;
      height: 72vh;
      overflow: auto;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      gap: 16px;
      .material_grid_file, .material_grid_folder {
        width: 19%;
        position: relative;
        border: 1px solid #F7F8FA;
        .material_grid_mask {
          position: absolute;
          z-index: 1;
          width: 100%;
          height: 100%;
          background: rgba(21, 26, 48, 0.4);
          box-shadow: 0px 0px 4px  rgba(0, 0, 0, 0.15);
          display: none;
          flex-direction: column;
          justify-content: space-between;
          .el-checkbox {
            margin-top: 16px;
            margin-left: 8px;
            /deep/ .el-checkbox__inner {
              // background: transparent;
            }
            /deep/ .el-checkbox__label {
              display: none;
            }
          }
          .mask_opratebox {
            text-align: center;
            img {
              cursor: pointer;
              &+img {
                margin-left: 4%;
              }
            }
          }
          .mask_textbox {
            padding: 12px 8px 18px;
            background: #FFFFFF;
            font-size: 14px;
            cursor: pointer;
            div {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .mask_time {
              color: #737373;
              font-size: 12px;
              margin-top: 4px;
            }
          }
        }
        &::after {
          padding-top: 100%;
          content: '';
          display: block;
        }
        .material-grid-img {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: contain;
          vertical-align: middle;
        }
        &:hover .material_grid_mask {
          display: flex;
        }
      }
      .material_grid_file {
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAIAAABLixI0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAFHGlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxNDUgNzkuMTYzNDk5LCAyMDE4LzA4LzEzLTE2OjQwOjIyICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyIgeG1sbnM6cGhvdG9zaG9wPSJodHRwOi8vbnMuYWRvYmUuY29tL3Bob3Rvc2hvcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RFdnQ9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZUV2ZW50IyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ0MgMjAxOSAoV2luZG93cykiIHhtcDpDcmVhdGVEYXRlPSIyMDE5LTEwLTIyVDE2OjMxOjQ5KzA4OjAwIiB4bXA6TW9kaWZ5RGF0ZT0iMjAxOS0xMC0yMlQxNjozMzoyMiswODowMCIgeG1wOk1ldGFkYXRhRGF0ZT0iMjAxOS0xMC0yMlQxNjozMzoyMiswODowMCIgZGM6Zm9ybWF0PSJpbWFnZS9wbmciIHBob3Rvc2hvcDpDb2xvck1vZGU9IjMiIHBob3Rvc2hvcDpJQ0NQcm9maWxlPSJzUkdCIElFQzYxOTY2LTIuMSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpmZGJmY2E1NC04Yzc4LTk3NGMtOGYyNC0xMmQ5MTMxNDI1ODgiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6ZmRiZmNhNTQtOGM3OC05NzRjLThmMjQtMTJkOTEzMTQyNTg4IiB4bXBNTTpPcmlnaW5hbERvY3VtZW50SUQ9InhtcC5kaWQ6ZmRiZmNhNTQtOGM3OC05NzRjLThmMjQtMTJkOTEzMTQyNTg4Ij4gPHhtcE1NOkhpc3Rvcnk+IDxyZGY6U2VxPiA8cmRmOmxpIHN0RXZ0OmFjdGlvbj0iY3JlYXRlZCIgc3RFdnQ6aW5zdGFuY2VJRD0ieG1wLmlpZDpmZGJmY2E1NC04Yzc4LTk3NGMtOGYyNC0xMmQ5MTMxNDI1ODgiIHN0RXZ0OndoZW49IjIwMTktMTAtMjJUMTY6MzE6NDkrMDg6MDAiIHN0RXZ0OnNvZnR3YXJlQWdlbnQ9IkFkb2JlIFBob3Rvc2hvcCBDQyAyMDE5IChXaW5kb3dzKSIvPiA8L3JkZjpTZXE+IDwveG1wTU06SGlzdG9yeT4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6l0qErAAAASklEQVQ4je3TwQkAMQhEUWdJYZZuW4JgOohzCSxk5vx5B0F0t02LiLExs4+JyMmS9aK1yF+jLLJz97H5671kybppsT9UVZl5CABsVSkOV58tY+kAAAAASUVORK5CYII=);
        background-repeat: repeat;
        .material-grid-img {
        }
      }
      .material_grid_folder {
        background: #F7F8FA;
        .material-grid-img {
          width: 36%;
          height: 36%;
          transform: translate(50%, 50%);
          margin-top: 14%;
          margin-left: 14%;
        }
      }
    }
  }
  .el-pagination {
    position: relative;
    /deep/ .el-pagination__sizes {
      position: absolute;
      right: 16px;
      .el-select .el-input .el-input__inner {
        height: 36px;
        line-height: 36px;
        background-color: #F7F8FA;
        border: none;
        color: #595959;
      }
    }
  }
}
</style>
<style lang="scss">

.material-hover {
  height: 450px;
  .hover-img {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAIAAABLixI0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAFHGlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxNDUgNzkuMTYzNDk5LCAyMDE4LzA4LzEzLTE2OjQwOjIyICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyIgeG1sbnM6cGhvdG9zaG9wPSJodHRwOi8vbnMuYWRvYmUuY29tL3Bob3Rvc2hvcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RFdnQ9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZUV2ZW50IyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ0MgMjAxOSAoV2luZG93cykiIHhtcDpDcmVhdGVEYXRlPSIyMDE5LTEwLTIyVDE2OjMxOjQ5KzA4OjAwIiB4bXA6TW9kaWZ5RGF0ZT0iMjAxOS0xMC0yMlQxNjozMzoyMiswODowMCIgeG1wOk1ldGFkYXRhRGF0ZT0iMjAxOS0xMC0yMlQxNjozMzoyMiswODowMCIgZGM6Zm9ybWF0PSJpbWFnZS9wbmciIHBob3Rvc2hvcDpDb2xvck1vZGU9IjMiIHBob3Rvc2hvcDpJQ0NQcm9maWxlPSJzUkdCIElFQzYxOTY2LTIuMSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpmZGJmY2E1NC04Yzc4LTk3NGMtOGYyNC0xMmQ5MTMxNDI1ODgiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6ZmRiZmNhNTQtOGM3OC05NzRjLThmMjQtMTJkOTEzMTQyNTg4IiB4bXBNTTpPcmlnaW5hbERvY3VtZW50SUQ9InhtcC5kaWQ6ZmRiZmNhNTQtOGM3OC05NzRjLThmMjQtMTJkOTEzMTQyNTg4Ij4gPHhtcE1NOkhpc3Rvcnk+IDxyZGY6U2VxPiA8cmRmOmxpIHN0RXZ0OmFjdGlvbj0iY3JlYXRlZCIgc3RFdnQ6aW5zdGFuY2VJRD0ieG1wLmlpZDpmZGJmY2E1NC04Yzc4LTk3NGMtOGYyNC0xMmQ5MTMxNDI1ODgiIHN0RXZ0OndoZW49IjIwMTktMTAtMjJUMTY6MzE6NDkrMDg6MDAiIHN0RXZ0OnNvZnR3YXJlQWdlbnQ9IkFkb2JlIFBob3Rvc2hvcCBDQyAyMDE5IChXaW5kb3dzKSIvPiA8L3JkZjpTZXE+IDwveG1wTU06SGlzdG9yeT4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6l0qErAAAASklEQVQ4je3TwQkAMQhEUWdJYZZuW4JgOohzCSxk5vx5B0F0t02LiLExs4+JyMmS9aK1yF+jLLJz97H5671kybppsT9UVZl5CABsVSkOV58tY+kAAAAASUVORK5CYII=);
    background-repeat: repeat;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .hover-info {
    position: absolute;
    background-color: rgba(0, 0, 0, 0.4);
    bottom: 0;
    width: 100%;
    padding: 8px;
    line-height: 20px;
    font-size: 14px;
    color: #fff;

    .hover-info-box {
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>